import { render, staticRenderFns } from "./ModelInformationBox.vue?vue&type=template&id=1b0006a5&scoped=true&"
import script from "./ModelInformationBox.vue?vue&type=script&lang=js&"
export * from "./ModelInformationBox.vue?vue&type=script&lang=js&"
import style0 from "./ModelInformationBox.vue?vue&type=style&index=0&id=1b0006a5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b0006a5",
  null
  
)

export default component.exports